import { createOverflowMenu } from './createOverflowMenu';
import { ListItemManager } from './types';

export const createListItemManager = (mainList: HTMLElement): ListItemManager => {
  let listItems = [...mainList.children].map((child) => child as HTMLElement);
  const { overflowMenuItem, overflowMenuList } = createOverflowMenu();
  let usingOverflowMenu = false;
  const addOverflowMenu = () => {
    if (!usingOverflowMenu) {
      usingOverflowMenu = true;
      mainList.appendChild(overflowMenuItem);
    }
  };
  const moveItemToOverflowMenu = () => {
    listItems = [...mainList.children] as HTMLElement[];
    listItems = listItems.filter((li) => li !== overflowMenuItem);
    if (listItems.length > 0) {
      const lastItem = listItems.pop();
      if (lastItem) {
        const lastItemLink = lastItem.querySelector('.header-link');
        overflowMenuList.prepend(lastItem);
        if (lastItemLink) {
          lastItemLink.classList.remove('header-link--inverted');
          lastItemLink.classList.add('header-link--normal');
        }
      }
    }
  };
  const checkListItemsFit = (navWidth: number) => {
    let totalListItemsWidth = 0;
    listItems = [...mainList.children].map((child) => child as HTMLElement);
    listItems.forEach((li) => {
      totalListItemsWidth += li.offsetWidth;
    });
    if (totalListItemsWidth > navWidth) {
      addOverflowMenu();
      moveItemToOverflowMenu();
      checkListItemsFit(navWidth);
    }
  };
  const resetOverflowMenu = () => {
    if (overflowMenuItem.parentNode) {
      usingOverflowMenu = false;
      const itemsToMove = [...overflowMenuList.children];

      itemsToMove.forEach((item) => {
        const itemLink = item.querySelector('.header-link');
        if (itemLink) {
          itemLink.classList.add('header-link--inverted');
          itemLink.classList.remove('header-link--normal');
        }
      });

      overflowMenuItem.parentNode.removeChild(overflowMenuItem);
      mainList.append(...itemsToMove);
    }
  };
  return {
    checkListItemsFit,
    resetOverflowMenu,
  };
};
